import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { NgxSpinnerService } from "ngx-spinner"; 
import { FormGroup, FormBuilder, Validators, FormControl, FormArray, AbstractControl, ValidationErrors, FormGroupDirective } from '@angular/forms';
import { HelperService } from '../helper.service';
import {Router} from "@angular/router";
import { CreateAdminComponent } from '../create-admin/create-admin.component';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
@Injectable({
providedIn: 'root'
})
@Component({
  selector: 'app-add-store',
  templateUrl: './add-store.component.html',
  styleUrls: ['./add-store.component.css']
})
export class AddStoreComponent implements OnInit {

  stateLoadingStore = false;
  PurchasedProducts = [];
  AdminData = [];
  Companies = [];
  countries = [];
  States = [];
  storehide = [];
  adminhide = [];
  timezones = [];
  Storemessage = [];
  Companymessage = [];
  Adminmessage = [];
  selectedCompanies = [];
  Stores = [];
  selectedCompaniesAndstores = [];
  selectedStores = [];
  store_added : string = '';
  Storeimage : string = '';
  primary_color : string = '';
  storeSubmitted = false;
  SubscriptionForm: FormGroup;
  subscriptionData: FormArray;
  successMessage = HelperService.successMessage;
  emptyCompany = true;
  companyId : string = '';
  adminSubmitted = false;
  adminmessage='';
  emailerror='';
  userexist:boolean = true;
  selectedAdmins = [];
  licenseCount = null;
  constructor(private fb: FormBuilder, private userService: UserService, private SpinnerService: NgxSpinnerService, private router: Router, private CreateAdminComponent:CreateAdminComponent) {
   }

  ngOnInit(): void {

    this.userService.getUserCompanies().subscribe((res) => {
      if(res.companies.length > 0){
        this.companyId = res.companies[0].company_id;
      }
    })
    this.userService.gettimezones().subscribe((data: any) => {
      this.timezones = data;
    });


    this.userService.getcountries().subscribe((data: any) => {
      this.countries = data.countries;
    })

  }

  setExistingStore(skillSets): FormArray {
    const formArray = new FormArray([]);
    skillSets.forEach(s => {
      formArray.push(this.fb.group({
        SubscriptionId: s.id,
        company_id: this.companyId,
        store_id: new FormControl([]),
        admin_id: new FormControl([])

      }));
    });

    return formArray;


  }
  callSelectedCompanies() {
    if (localStorage.getItem('selectedCompanies') !== null) {
      const SelectedCompanies = JSON.parse(localStorage.getItem('selectedCompanies'));
    }

  }


  store_update = new FormGroup({
    id: new FormControl(''),
    Storeimage: new FormControl(''),
    store_name: new FormControl('', [Validators.required]),
    owner_name: new FormControl('', [Validators.required]),
    contact_number: new FormControl('', [Validators.required]),
    email_Address: new FormControl('', [Validators.required]),
    address_line1: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
    address_line2: new FormControl(''),
    city: new FormControl('', [Validators.required]),
    State: new FormControl('', [Validators.required]),
    zip: new FormControl("", [Validators.required]),
    timezone: new FormControl("", [Validators.required]),
    primary_color: new FormControl(''),
  });

  get store_form(){
    return this.store_update.controls;
  }

  store_submit(event){
    event.preventDefault();
    console.log(this.companyId);
    this.storeSubmitted = true;
    this.SpinnerService.show(); 
   // console.log(this.store_update.value);
    if (this.store_update.invalid) {
      this.SpinnerService.hide(); 
      return;
    }
    //console.log(this.store_update.value);
    const storeData = this.store_update.value;
    const store_id = this.store_update.value.id;
    const country = this.store_update.value.country;
    const company_id = this.companyId;
   /*  if(store_id){
      this.userService.updateStore(storeData).subscribe(resp => {
        this.SpinnerService.hide(); 
        console.log(resp);
        if (resp.status == 2) {
        } else {
          this.store_added = this.successMessage;
          this.resetStoreForm();
          setTimeout(() => {
            this.store_added = '';
            const close_store_modal = document.querySelector('.close_store_modal');
            if (close_store_modal instanceof HTMLElement) {
              close_store_modal.click();
            }
            const currentRoute = this.router.url;
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentRoute]); // navigate to same route
            });
          }, 1000);
        }
      })  
    }
    else{ */
      this.userService.addNewStore(storeData,company_id).subscribe(resp => {
        this.SpinnerService.hide(); 
        //console.log(resp);
        if (resp.status == 2) {
        } else {
          this.store_added = this.successMessage;
          this.resetStoreForm();
          setTimeout(() => {
            this.store_added = '';
            const close_store_modal = document.querySelector('.close_store_modal');
            if (close_store_modal instanceof HTMLElement) {
              close_store_modal.click();
            }
            const currentRoute = this.router.url;
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentRoute]); // navigate to same route
            });
          }, 1000);
        }
      })  
    /* } */
  }
  changeStateStore(event) {
    this.stateLoadingStore = true;
    this.userService.getRegions(event).subscribe(res => {
      this.stateLoadingStore = false;
      this.States = res.regions;
    })
    this.store_update.get('State').setValue("");

  }

  handleChangeComplete(event){
    const primary_color = event;
    this.store_update.get('primary_color').setValue(primary_color);
    (<HTMLInputElement>document.getElementById("cstm_color_new")).value = event;
    (<HTMLInputElement>document.getElementById("cstm_color_new")).style.color = event;
    (<HTMLInputElement>document.getElementById("cstm_color_new")).style.background = event; 
     //this.CompanyForm['controls']['StoresArray']['controls'][index]['controls'].primary_color.patchValue(event);
  }
  addStore(){
    this.resetStoreForm();
  }
  resetStoreForm(){
    this.Storeimage = null;
    this.storeSubmitted = false;
    //console.log('addStore');
    this.store_update.reset();
    this.store_update.get('timezone').setValue("");
    this.store_update.get('State').setValue("");
    this.store_update.get('country').setValue("");
    this.store_update.get('primary_color').setValue("");
    (<HTMLInputElement>document.getElementById("cstm_color_new")).value = "";
    (<HTMLInputElement>document.getElementById("cstm_color_new")).style.color = "";
    (<HTMLInputElement>document.getElementById("cstm_color_new")).style.background = ""; 
  }
  selectImageStore(event) {
    this.SpinnerService.show(); 
    let file = event.target.files[0];
    
    // File Preview
    const reader = new FileReader();
    reader.onload = (e: any) => {
      //console.log(e.target.result);
      this.Storeimage = e.target.result;
      this.store_update.get('Storeimage').patchValue(e.target.result);
      this.SpinnerService.hide(); 
    }
    reader.readAsDataURL(file)

  }
    updateUrl(event,store_id,index) {
    this.Stores[index]['Storeimage'] = 'assets/images/profiles.png';
  }




}
